import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';

import Button from '@atlaskit/button';
import Icon from '@atlaskit/icon';
import { Box, xcss } from '@atlaskit/primitives';

import { PeopleGroupIcon } from './icons/PeopleIcon';

export type Source = 'homeScreen' | 'pageTree';

const ContainerStyle = xcss({
	paddingTop: 'space.200',
	paddingRight: 'space.150',
	paddingBottom: 'space.200',
	paddingLeft: 'space.150',
});

export function InviteButtonComponent({
	onClick,
}: {
	onClick: (e: React.MouseEvent<HTMLElement>) => void;
}) {
	const [boxStyle, InviteButton] = [ContainerStyle, Button];

	return (
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
		<div className="persistent-invite-button">
			{/* eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage */}
			<Box xcss={boxStyle} testId="persistent-invite-people-button">
				<InviteButton shouldFitContainer onClick={onClick}>
					<FormattedMessage
						id="persistent-invite-button.persistent.invite.button"
						defaultMessage="Invite people"
						description="button text for inviting people to Confluence"
					/>
				</InviteButton>
			</Box>
		</div>
	);
}

export function IconButtonComponent({
	onClick,
}: {
	onClick: (e: React.MouseEvent<HTMLElement>) => void;
}) {
	const intl = useIntl();
	return (
		<Button
			appearance="subtle"
			onClick={onClick}
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
			className="persistent-invite-icon-button"
		>
			<Icon
				glyph={PeopleGroupIcon}
				label={intl.formatMessage({
					id: 'persistent-invite-button.persistent.invite.button.icon.label',
					defaultMessage: 'Invite people',
					description: 'Label text for invite people icon',
				})}
				size="medium"
			/>
		</Button>
	);
}
